import React, { Fragment } from "react";

import "./BTDForm.css";
import Input from "../../Form/Input/Input";
import Button from "../../Button/Button";
import ImageBox from "../../ImageBox/ImageBox";
import { required, length } from "../../../util/validators";
import { generateBase64FromImage } from "../../../util/image";

import Select from "react-select";

const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: "white" }),
  theme: (styles) => ({ ...styles, borderRadius: "8px"}),
  menu: (styles) => ({ ...styles, zIndex: 9999 }),
};

const POST_FORM = {
  title: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 2 })],
  },
  brand: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required],
  },
  warranty: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required],
  },
  size: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required],
  },
  categoryCode: {
    value: 0,
    valid: true,
    touched: true,
    errorMessage: "",
    validators: [],
  },
};

class BTDForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      brands: [],
      warranties: [],
      sizes: [],
      postForm: POST_FORM,
      formIsValid: false,
      imagePreview: null,
    };
  }
 
  componentDidUpdate(previousProps, previousState) {
    if (previousProps.editingData !== this.props.editingData) {
      if (Object.keys(this.props.editingData).length !== 0) {
        
        let updatedForm = POST_FORM;
        
        updatedForm["title"].value = this.props.editingData.title;
        updatedForm["title"].valid = true;
        updatedForm["title"].touched = true;       

        this.setState({
          postForm: updatedForm,
          formIsValid: true,
        });
      }else{
        let updatedForm = POST_FORM;
        for (const inputName in updatedForm) {
          updatedForm[inputName].value = "";
          updatedForm[inputName].valid = false;
          updatedForm[inputName].touched = false;          
          updatedForm[inputName].errorMessage = "";
          if (inputName === "categoryCode") {
            updatedForm[inputName].value = 0;
            updatedForm[inputName].valid = true;
          }
        }

        this.setState({
          postForm: updatedForm,
          formIsValid: false,
        });
      }
      if (this.props.label===" برند") {
        if (this.props.brands.length !== 0) {
          let tempBrands=[];
          this.props.brands.map(data => {
            var Form = new Object();
            Form.value= data.code;
            Form.label= data.title+ " " +data.enTitle;
            tempBrands.push(Form);
          })
          
          this.setState({brands: tempBrands})
        }        
      }      
      if (this.props.label===" سایز") {
        if (this.props.sizes.length !== 0) {
          let tempSizes=[];
          this.props.sizes.map(data => {
            var Form = new Object();
            Form.value= data.id;
            Form.label= data.title;
            tempSizes.push(Form);
          })
          console.log(this.props.sizes);
          
          this.setState({sizes: tempSizes})
        }        
      }
      if (this.props.label===" گارانتی") {
        if (this.props.warranties.length !== 0) {
          let tempWarranties=[];
          this.props.warranties.map(data => {
            var Form = new Object();
            Form.value= data.id;
            Form.label= data.title+ " (" +data.period+")";
            tempWarranties.push(Form);
          })
          
          this.setState({warranties: tempWarranties})
        }        
      }        
    }
    if (previousProps.brands !== this.props.brands) {
      if (this.props.label===" برند") {
        if (this.props.brands.length !== 0) {
          let tempBrands=[];
          this.props.brands.map(data => {
            var Form = new Object();
            Form.value= data.code;
            Form.label= data.title+ " " +data.enTitle;
            tempBrands.push(Form);
          })
          
          this.setState({brands: tempBrands})
        } else {
          this.setState({brands: []})
        }         
      } 
    }
    if (previousProps.warranties !== this.props.warranties) {
      if (this.props.label===" گارانتی") {
        if (this.props.warranties.length !== 0) {
          let tempWarranties=[];
          this.props.warranties.map(data => {
            var Form = new Object();
            Form.value= data.id;
            Form.label= data.title+ " (" +data.period+")";
            tempWarranties.push(Form);
          })
          
          this.setState({warranties: tempWarranties})
        } else {
          this.setState({warranties: []})
        }       
      } 
    }
  }

  postInputChangeHandler = (input, value) => {
    this.setState((prevState) => {
      let isValid = true;
      let errorMessage = "";
      for (const validator of prevState.postForm[input].validators) {
        isValid = isValid && validator(value).hasError;
        errorMessage =
          !isValid && errorMessage === "" ? validator(value).errorMessage : errorMessage;
      }
      const updatedForm = {
        ...prevState.postForm,
        [input]: {
          ...prevState.postForm[input],
          valid: isValid,
          errorMessage: errorMessage,
          value: value,
        },
      };
      let formIsValid = true;
      formIsValid = updatedForm["title"].valid;
      

      return {
        postForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  };


  inputSelectChangeHandler(event, selector) {    
    this.setState((prevState) => {
      console.log(event);
      let isValid = true;
      let errorMessage = "";
      for (const validator of prevState.postForm[selector.name]
        .validators) {
        isValid = isValid && validator(event.value.toString()).hasError;
        errorMessage =
          !isValid && errorMessage === ""
            ? validator(event.value.toString()).errorMessage
            : errorMessage;
      }
      const updatedForm = {
        ...prevState.postForm,
        [selector.name]: {
          ...prevState.postForm[selector.name],
          valid: isValid,
          value: event,
          errorMessage: errorMessage,
        },
      };
      let formIsValid = true;
      formIsValid = formIsValid && updatedForm[selector.name].valid;
        
      return {
        postForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  }



  inputBlurHandler = (input) => {
    this.setState((prevState) => {
      return {
        postForm: {
          ...prevState.postForm,
          [input]: {
            ...prevState.postForm[input],
            touched: true,
          },
        },
      };
    });
  };

  cancelPostChangeHandler = () => {
    this.setState(
      {
        postForm: POST_FORM,
        formIsValid: false,
      });
    // this.props.onCancelEdit();
    this.props.toggleClass();
  };

  acceptPostChangeHandler = () => {
    if (this.state.formIsValid) {
      const post = {
        title: this.state.postForm.title.value,        
        brandCode: this.state.postForm.brand.value.value,
        sizeCode: this.state.postForm.size.value.value,
        warrantyCode: this.state.postForm.warranty.value.value,
        categoryCode: this.props.categoryCode,
        label: this.props.label,
        editingCode: this.props.editingData.code || 0,
      };
      this.props.onAcceptModal(post);

      let updatedForm = POST_FORM;
      for (const inputName in updatedForm) {
        updatedForm[inputName].value = "";
        updatedForm[inputName].valid = false;
        updatedForm[inputName].touched = false;
        updatedForm[inputName].errorMessage = "";
        if (inputName === "categoryCode") {
          updatedForm[inputName].value = 0;
          updatedForm[inputName].valid = true;
        }
      }

      this.setState({
        postForm: updatedForm,
        formIsValid: false,
        imagePreview: null,
      });
    }else{
      this.setState((prevState) => {
        let updatedForm = { ...prevState.postForm };

        if (this.props.label !== " نوع" && this.props.label !== " دسته‌بندی") {
          let isValid = true;
          let errorMessage = "";
          for (const validator of prevState.postForm["title"].validators) {
            isValid =
              isValid &&
              validator(prevState.postForm["title"].value).hasError;
            errorMessage =
              !isValid && errorMessage === ""
                ? validator(prevState.postForm["title"].value).errorMessage
                : errorMessage;
          }
          updatedForm = {
            ...updatedForm,
            ["title"]: {
              ...updatedForm["title"],
              valid: isValid,
              errorMessage: errorMessage,
            },
          };
        } else if (this.props.label !== " برند") {
          let isValid = true;
          let errorMessage = "";
          for (const validator of prevState.postForm["brand"].validators) {
            isValid = isValid && validator(prevState.postForm["brand"].value.value).hasError;
            errorMessage =
              !isValid && errorMessage === ""
                ? validator(prevState.postForm["brand"].value.value).errorMessage
                : errorMessage;
          }
          updatedForm = {
            ...updatedForm,
            ["brand"]: {
              ...updatedForm["brand"],
                valid: isValid,
                errorMessage: errorMessage,
            },
          };
        } else if (this.props.label !== " سایز") {
          let isValid = true;
          let errorMessage = "";
          for (const validator of prevState.postForm["size"].validators) {
            isValid = isValid && validator(prevState.postForm["size"].value.value).hasError;
            errorMessage =
              !isValid && errorMessage === ""
                ? validator(prevState.postForm["size"].value.value).errorMessage
                : errorMessage;
          }
          updatedForm = {
            ...updatedForm,
            ["size"]: {
              ...updatedForm["size"],
                valid: isValid,
                errorMessage: errorMessage,
            },
          };
        } else if (this.props.label !== " گارانتی") {
          let isValid = true;
          let errorMessage = "";
          for (const validator of prevState.postForm["warranty"].validators) {
            isValid = isValid && validator(prevState.postForm["warranty"].value.value).hasError;
            errorMessage =
              !isValid && errorMessage === ""
                ? validator(prevState.postForm["warranty"].value.value).errorMessage
                : errorMessage;
          }
          updatedForm = {
            ...updatedForm,
            ["warranty"]: {
              ...updatedForm["warranty"],
                valid: isValid,
                errorMessage: errorMessage,
            },
          };
        }

        return {
          postForm: updatedForm,
        };
      });
    }
  };

  render() {
    return (
      <Fragment>
        <div className="mn-grid__col mn-grid__col--sm-6 mn-grid__col--lg-10 uk-padding-remove-left uk-padding-remove-right">
          <div className="mn-RD-profile__add-doc uk-width-1-1">
            <span className="uk-width-1-1 uk-text-right mn-RD-profile__add-doc-title">
              بارگذاری اطلاعات جدید
            </span>
            <form onSubmit={e => { e.preventDefault(); }}>
              {(this.props.label === " دسته‌بندی" || this.props.label === " نوع") && (
              <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
                <Input 
                  id="title"
                  label={"عنوان " + this.props.label}
                  type="text"
                  control="input"
                  required="required"
                  onChange={this.postInputChangeHandler}
                  onBlur={this.inputBlurHandler.bind(this, "title")}
                  valid={this.state.postForm["title"].valid}
                  touched={this.state.postForm["title"].touched}
                  value={this.state.postForm["title"].value || ""}
                  validationError={
                    !this.state.valid &&
                    this.state.postForm["title"].errorMessage
                  }
                />
              </div>
              )}
              {this.props.label === " برند" && (
                <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
                  <label htmlFor="" className="uk-form-label">نام برند:</label>
                    <div className={["field-wrapper",
                            this.state.postForm["brand"].errorMessage === "" ? "" : "has-error",
                        ].join(" ")}>
                          
  
                          <Select
                            name="brand"
                            control="input"
                            value={this.state.selectedType}
                            options={this.state.brands}
                            styles={colourStyles}
                            theme={colourStyles.theme}
                            onChange={this.inputSelectChangeHandler.bind(this)}
                            onBlur={this.inputBlurHandler.bind(this, "brand")}
                            value={this.state.postForm["brand"].value}
                            valid={this.state.postForm["brand"].valid}
                            touched={this.state.postForm["brand"].touched}
                          />
                         
                        
                        <div id={2} className="error error-msg">
                            {this.state.postForm["brand"].errorMessage}
                        </div>
                    </div>
                    <div></div>
                </div>
              )}
              {this.props.label === " گارانتی" && (
                <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
                  <label htmlFor="" className="uk-form-label">نام گارانتی:</label>
                    <div className={["field-wrapper",
                            this.state.postForm["warranty"].errorMessage === "" ? "" : "has-error",
                        ].join(" ")}>
                          
                          <Select
                            name="warranty"
                            control="input"
                            value={this.state.selectedType}
                            options={this.state.warranties}
                            styles={colourStyles}
                            theme={colourStyles.theme}
                            onChange={this.inputSelectChangeHandler.bind(this)}
                            onBlur={this.inputBlurHandler.bind(this, "warranty")}
                            value={this.state.postForm["warranty"].value}
                            valid={this.state.postForm["warranty"].valid}
                            touched={this.state.postForm["warranty"].touched}
                          />

                        <div id={2} className="error error-msg">
                            {this.state.postForm["warranty"].errorMessage}
                        </div>
                    </div>
                    <div></div>
                </div>
              )}
              {this.props.label === " سایز" && (
                <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
                  <label htmlFor="" className="uk-form-label">نام سایز:</label>
                    <div className={["field-wrapper",
                            this.state.postForm["size"].errorMessage === "" ? "" : "has-error",
                        ].join(" ")}>
                          
  
                          <Select
                            name="size"
                            control="input"
                            value={this.state.selectedType}
                            options={this.state.sizes}
                            styles={colourStyles}
                            theme={colourStyles.theme}
                            onChange={this.inputSelectChangeHandler.bind(this)}
                            onBlur={this.inputBlurHandler.bind(this, "size")}
                            value={this.state.postForm["size"].value}
                            valid={this.state.postForm["size"].valid}
                            touched={this.state.postForm["size"].touched}
                          />
                         
                        
                        <div id={2} className="error error-msg">
                            {this.state.postForm["size"].errorMessage}
                        </div>
                    </div>
                    <div></div>
                </div>
              )}
              {/* {this.props.label === " برند" && (
                <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
                  <Input
                    id="enTitle"
                    label={"عنوان انگلیسی " + this.props.label}
                    type="text"
                    control="input"
                    required="required"
                    onChange={this.postInputChangeHandler}
                    onBlur={this.inputBlurHandler.bind(this, "enTitle")}
                    valid={this.state.postForm["enTitle"].valid}
                    touched={this.state.postForm["enTitle"].touched}
                    value={this.state.postForm["enTitle"].value || ""}
                    validationError={
                      !this.state.valid &&
                      this.state.postForm["enTitle"].errorMessage
                    }
                  />
                </div>
              )}
              {this.props.label === " برند" && (
                <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-10">
                  <ImageBox
                    id="image"
                    label={"تصویر " + this.props.label}
                    type="text"
                    mode="complex"
                    control="input"
                    required="required"
                    onChange={this.postInputChangeHandler}
                    onBlur={this.inputBlurHandler.bind(this, "image")}
                    imageUrl={this.state.imagePreview}
                    valid={this.state.postForm["image"].valid}
                    touched={this.state.postForm["image"].touched}
                  />
                </div>
              )} */}
            </form>
            <div className="uk-flex uk-flex-right uk-flex-bottom">
              <Button
                design="next"
                mode=""
                type="submit"
                loading={false}
                onClick={this.acceptPostChangeHandler}
              >
                {!this.props.isEditing ? "ثبت و بارگذاری" : "ویرایش و بارگذاری"}
              </Button>
              <Button
                design="reset"
                mode=""
                type="submit"
                loading={false}
                onClick={this.cancelPostChangeHandler}
              >
                {}
              </Button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default BTDForm;
